export default [
  {
    path: '/misura21',
    name: 'Misura21AdminView',
    component: () => import('./views/Misura21AdminView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/calendar',
    name: 'Misura21CalendarView',
    component: () => import('./views/Misura21UserCalendarView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/user/:uid',
    name: 'Misura21UserCalendarView',
    component: () => import('./views/Misura21UserCalendarView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  {
    path: '/misura21/review',
    name: 'Misura21ExternalReviewView',
    component: () => import('./views/Misura21ExternalReviewView.vue'),
    meta: { requiresAuth: true, requiresRole: ['org_admin', 'org_external'] },
  },
  {
    path: '/misura21/review/:id_voce_azienda',
    name: 'Misura21ExternalFarmDetailView',
    component: () => import('./views/Misura21ExternalFarmDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: ['org_admin', 'org_external'] },
  },
  {
    path: '/misura21/my',
    name: 'Misura21MyOverviewView',
    component: () => import('./views/Misura21ExternalReviewView.vue'),
    props: { mode: 'my' },
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/my/:id_voce_azienda',
    name: 'Misura21MyFarmDetailView',
    component: () => import('./views/Misura21ExternalFarmDetailView.vue'),
    props: { mode: 'my' },
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/user/:uid/:id_voce_azienda/:report_type/:report_id?',
    name: 'Misura21ReportEditView',
    component: () => import('./views/Misura21ReportEditView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/visits',
    name: 'FarmerVisitsView',
    component: () => import('./views/Misura21ExternalReviewView.vue'),
    props: { mode: 'my' },
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/field',
    name: 'Misura21FieldView',
    component: () => import('./views/Misura21FieldView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/misura21/field/:id_calendar',
    name: 'Misura21EventView',
    component: () => import('./views/Misura21EventView.vue'),
    meta: { requiresAuth: true },
  },
]
